import React, { useEffect, useState } from 'react';
import styled from 'styled-components'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";

import News from '../News';
import Header from '../Header';
import NavFooter from '../NavFooter';
import GoogleIcon from '@mui/icons-material/Google';
import CloseIcon from '@mui/icons-material/Close';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';

import { getAuth, signInWithPopup, GoogleAuthProvider } from "firebase/auth";
import { doc, setDoc } from "firebase/firestore"; 
import { getFirestore } from "firebase/firestore"












const Welcome = () => {


 const [modal, setModal] = useState(null)
const provider = new GoogleAuthProvider();
const auth = getAuth();
const db = getFirestore()



const handleLogin =  () => {

  
signInWithPopup(auth, provider)
  .then((result) => {
    
    const credential = GoogleAuthProvider.credentialFromResult(result);
    const token = credential.accessToken;    
    const user = result.user;
    return user;

    
  }).then((user) => {
    setDoc(doc(db, "emails", user.uid), {id: user.uid,email:user.email});
    setModal(false);
    if(localStorage.getItem('googleSignin') == null){
      localStorage.setItem('googleSignin', 'already');
      localStorage.setItem('token', user.uid);
    }
    
  })
  .catch((error) => {
    
    const errorCode = error.code;
    const errorMessage = error.message;
    console.log(errorMessage,errorCode)
    
    const email = error.email;
    
    const credential = GoogleAuthProvider.credentialFromError(error);
  
  });

}

const closeModal = () =>{

  setModal(false);
}

useEffect(()=>{
  if(localStorage.getItem('googleSignin') === "already"){
    setModal(false)
  }else{
    setModal(true)
  }
},[])




      var settings = {
      dots: false,
      infinite: true,
      speed: 1000,
      slidesToShow: 3,
      slidesToScroll: 1,
      initialSlide: 0,
      autoplay:true,
       autoplaySpeed: 5300,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            dots: false
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            initialSlide: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        }
      ]
    };

   

    

    return (
        <>
       
          {modal && (
            <Modal>
              <div className="content">
                 <CloseIcon className='closeicon' onClick={closeModal}/>
                 <p className='newstitle'>INSCRIPTION NEWSLETTER</p>
                 <p className="newsletter">Ne manquez aucune de nos soirée! Inscrivez-vous à la newsletter en vous connectant avec votre compte Google</p>
                <p className="googleAccount" onClick={handleLogin}>Se connecter avec Google <GoogleIcon className='googleIcon'/></p>
                
               <span onClick={closeModal}>une autre fois peut-être</span>
              </div>
             </Modal>
          ) }
          
        <Header />  
          <News/>
         
        <Footer>
           <ul className="social_media">
             <li id="follow">Retrouvez nous sur </li>
            <li>
              <a href="https://www.instagram.com/lessentielbar/?hl=fr">
                <InstagramIcon/>
              </a>
            </li>
            <li>
              <a href="https://www.facebook.com/LEssentiel-Cocktail-Bar-347876362684784/">
                <FacebookIcon/>
              </a>
            </li>            
            
          </ul>
        <Caroussel {...settings}>

            <Wrap>
            <a href="/carte">
               <div className='text'>
              <h3>Whisky</h3>
              <p>L'Essentiel de l'Ecosse au Japon</p>
              </div>
              <img src="images/whisky.jpg" alt="" />
              </a>
          </Wrap>
          <Wrap>
            <a href="/carte">
                
              <div className='text'>
              <h3>Bière</h3>
              <p>Brassez de l'air, buvez une mousse.</p>
              </div>
              <img src="images/beer.jpg" alt="" />
              </a>
          </Wrap>
          <Wrap>
            <a href="/carte">
               <div className='text'>
              <h3>Whisky</h3>
              <p>Voyagez de L'Ecosse au Japon.</p>
              </div>
              <img src="images/whisky.jpg" alt="" />
              </a>
          </Wrap>
          <Wrap>
          <a href="/carte">
              <div className='text'>
              <h3>Cocktail</h3>
              <p>Dégustez nos mélanges de saveurs.</p>
              </div>
              <img src="images/cocktail.jpg" alt="" />
              
              </a>
          </Wrap>


        </Caroussel>
           <NavFooter/>  
        </Footer>
       
        </>
        
         
      
    );
};








const Modal = styled.div`

width: 100%;
height: 100%;
background: rgb(0,0,0,0.9);
position:absolute;
top:0px;
left:0px;
z-index:222;
.content{

position:absolute;
background-color: #f9f9f9;
border-radius: 12px;
width: 90%;
height:40%;
top:50%;
left:50%;
transform: translate(-50%,-50%);
z-index:9999;
box-shadow: rgb(0,0,0,1) 0px 0px 5px 5px;
display:flex;
flex-direction: column;
justify-content: space-between;
align-items:center;
padding: 25px 0px;

.closeicon{
  position:absolute;
  top:5px;
  right:5px;
  font-size: 16px;
  cursor:pointer;
}

.googleIcon{
  font-size: 26px;
  padding: 0px 0px 0px 0px ;
  color: rgb(119,221,119);
  margin-left: 10px;
}
  .googleAccount{
    font-family: 'Lato';
    font-weight: 600;
    font-size: 16px;
    color: rgb(20,26,28);
    margin-bottom: 10px;
    border: 1px solid rgb(20,26,28);
    padding: 5px 10px;
    border:none;
    border-radius: 5px;
    box-shadow: 0px 5px 5px 0px rgb(20,26,28,0.5);
    cursor: pointer;
    display:flex;
    align-items:center;
  }

  .newsletter{
    width: 90%;
    text-align:center;
    font-weight: 600;
    font-size: 18px;
    padding: 5px 0px;
  }
  .newstitle{
    color:#096a09;
    font-family:'Lato';
    font-weight: 600;
    padding: 10px 0px;
    font-size: 18px;
  }

  span{
  color:#096a09;
  cursor:pointer;
  padding: 3px 5px;
  position:relative;
  top:0px;
  left: 50px;
  
  background-color: transparent;

    &:hover{
      color: #096a09;
    }
  }
}



`

const Footer = styled.div`

width: 90vw;
bottom:0px;


left:50%;
transform: translateX(-50%);

position: fixed;

.social_media{
  display:flex;
  
  justify-content: center;
  align-items:flex-end;  
  list-style:none;
  position:absolute;
  left: 50%;
  transform: translateX(-50%);
  top: -30px;
  gap:20px;
  
  #follow{
    width: 90px;
    display:flex;
    justify-content: center;
    align-items:center;
    margin-right: 10px;
    font-size: 10px;
    position:relative;
    top: -4px;
    display:none;
  }


  li{
    text-decoration: none;
    transform: scale(1.5);
    
    
    color: #b1b1b1;
    font-size: 10px;
   

    a{
      color: rgb(159, 220, 150);
    
    
    }
    
    
  }

}



`

const Caroussel = styled(Slider)`

    

  & > button {
    opacity: 0;
    height: 100%;
    width: 5vw;
    z-index: 1;
    &:hover {
      opacity: 1;
      transition: opacity 0.2s ease 0s;
    }
  }
  ul li button {
    &:before {
      font-size: 10px;
      color: rgb(150, 150, 171);
    }
  }
  li.slick-active button:before {
    color: white;
  }


  .slick-list {
    overflow: initial;
     box-sizing: initial;
    padding: 30px 0px;
  }
  .slick-slide {
    
    padding: 0 1px;
  }

  @media (min-width: 446px){
    display:none;
    position: relative;
    left:50%;
    transform: translateX(-50%);
    width: 80%;
    height:100px;
    bottom:10px;
    padding-bottom: 30px;
  }
  

`
const Wrap = styled.div`
  border-radius: 4px;
  cursor: pointer;
  position: relative;
  display: grid;
  grid-template-columns: repeat(3, minmax(1, 1fr));
  

  
  
  a {
    border-radius: 4px;
    box-shadow: rgb(0 0 0 / 69%) 0px 26px 30px -10px,
      rgb(0 0 0 / 73%) 0px 16px 10px -10px;
    cursor: pointer;
    display: block;
    position: relative;
    padding: 0px;
    position:relative;
    text-decoration: none;

    img {
        
    opacity: 0.9;
     inset:0;
      width: 100%;
      height: 100%;
      border-radius: 2px;
      
    }
    
    .text{
        color: rgb(249,249,249);
       
        letter-spacing:0.8px;
        position:absolute;
        width: 90%;
        top:50%;
        left:50%;
        transform: translate(-50%,-50%);
        padding: 15px 20px;
        opacity:1;
        z-index: 2;
        border: 1px solid #f9f9f9;

        h3{
             font-family: 'Lobster';
        font-weight: 200;
        }
        p{
            font-family: 'Poppins';
            font-size: 14px;

        }
    }
     transition: 200ms cubic-bezier(0.25,0.46,0.44,0.94);

    

  }
`;

export default Welcome;